import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import * as Yup from "yup";
import "./style.scss";

import UpdateDetailsComponent from "@/components/updateDetails";
import { useAppDispatch, useAppSelector } from "@/redux/store";
import {
  selectGetResponseUpdateDetails,
  selectRegistrationDataStatus
} from "@/util/selectors";
import { resetResponseUpdateDetailsData } from "@/redux/actions/authConfig.action";
import { useHistory } from "react-router-dom";
import BackIcon from "@/images/back_arrow.svg";
import { handleMandatoryFields } from "@/redux/actions/homepage.action";
import { useRouteSlug } from "@/hooks";
import { hideLoadingIndicator } from "@/redux/actions/common.action";

type MissedField = {
  enabled: boolean;
  mandatory: boolean;
};

export type DynamicUpdateProfileFields = {
  firstname?: MissedField;
  email?: MissedField;
  phone?: MissedField;
  gender?: MissedField;
  country?: MissedField;
  birthday?: MissedField;
  nationality?: MissedField;
  password?: MissedField;
};

type Props = {
  isMobile?: boolean;
  updateUserDetails?: boolean;
  onBack?: () => void;
  onConfirm?: any;
  handleOtpCallback?: any;
  signIn?: boolean;
};

const UpdateDetails = ({
  isMobile = false,
  updateUserDetails = false,
  onBack,
  onConfirm,
  handleOtpCallback,
  signIn
}: Props) => {
  const [missedFields, setMissedFields] =
    useState<DynamicUpdateProfileFields>(null);
  const [token, setToken] = useState("");
  const [userProfile, setUserProfile] = useState({});
  const dispatch = useAppDispatch();
  const responseUpdateDetails = useAppSelector(selectGetResponseUpdateDetails);

  const history = useHistory();
  const routeSlug = useRouteSlug();
  const { t } = useTranslation("auth");

  const onAuthMissingFieldsError = response => {
    if (response.requiredFields || response.optionalFields) {
      const requiredFields = response.requiredFields?.reduce((acc, key) => {
        acc[key] = { enabled: true, mandatory: true };
        return acc;
      }, {});
      const optionalResult = response.optionalFields?.reduce((acc, key) => {
        acc[key] = { enabled: true };
        return acc;
      }, {});

      if (
        !response.userProfile &&
        Object.prototype.hasOwnProperty.call(requiredFields, "firstname")
      ) {
        requiredFields.fullname = requiredFields.firstname;
        delete requiredFields.firstname;
      }

      setMissedFields({ ...optionalResult, ...requiredFields });
      setToken(response.token);
      setUserProfile(
        response.userProfile
          ? response.userProfile
          : { phone: "", countryId: 236 }
      );
    }
  };

  useEffect(() => {
    if (responseUpdateDetails) {
      onAuthMissingFieldsError(responseUpdateDetails);
    }
  }, [responseUpdateDetails]);

  useEffect(() => {
    dispatch(hideLoadingIndicator());
    if (!responseUpdateDetails) {
      history.push(`/${routeSlug}/`);
    }
  }, []);

  if (!responseUpdateDetails) null;

  return (
    <div className="successContainer social">
      <button className="mv_back" onClick={onBack}>
        <img src={BackIcon} style={{ height: "40px" }} />
      </button>
      <h2 className="title">{t("updateDetails")}</h2>
      <UpdateDetailsComponent
        // prefillPhone={"971503334343"}
        data={missedFields}
        token={token}
        updateAction={signIn ? handleMandatoryFields : onConfirm}
        otpCallback={handleOtpCallback}
        userProfile={userProfile}
        className="updateOptionalData"
        socialFlow
        isSignUpFlow
        isSignIn={signIn}
        enableDraft
      />
    </div>
  );
};
//

export default UpdateDetails;
